import React from "react";
import Location from "../../../Assets/Image/svg/Location.svg";
import Call from "../../../Assets/Image/svg/Call.svg";
import Message from "../../../Assets/Image/svg/Message 35.svg";
import { AiOutlineWhatsApp, AiOutlineInstagram } from "react-icons/ai";
import { FaTelegramPlane } from "react-icons/fa";
import { NavLink, Link } from "react-router-dom";
import { HashLink, NavHashLink } from "react-router-hash-link";

function Footer() {
    const handleClick = () => {
        window.open(
            "https://logo.samandehi.ir/Verify.aspx?id=124402&p=rfthuiwkaodsaodsobpduiwk",
            "popup",
            "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30)"
        );
    };

    return (
        <footer className="footer bg-purple px-[6.5rem] pt-[4rem] pb-[3rem] flex items-start justify-center text-[#fff]">
            <div>
                <p className="  font-bold text-[1.6rem] leading-[3.2rem]">
                    درباره ما
                </p>
                <p className="leading-[2.4rem] font-normal text-[1.4rem] mt-[1.2rem] max-w-[25.8rem]">
                    بوت‌وب آمده است تا برگزاری بوت‌کمپ‌های آنلاین را از همیشه
                    آسان تر کند. وبینار و بوت‌کمپ برگزار کنید، با دیگر افراد
                    آشنا شوید، تجربیات متفاوتی بدست آورید و حتی کسب درآمد کنید.
                </p>
            </div>
            <div className="mr-[4.55rem]">
                <p className="font-bold text-[1.6rem] leading-[3.2rem]">
                    لینک های مفید
                </p>
                <HashLink smooth key="homepage" to="/#top">
                    <p className="leading-[2.4rem] font-normal text-[1.4rem] mt-[0.5rem] ">
                        صفحه اصلی
                    </p>
                </HashLink>
                <HashLink smooth key="bootcamps" to="/bootcamp#top">
                    <p className="leading-[2.4rem] font-normal text-[1.4rem] mt-[0.5rem] ">
                        بوت کمپ ها
                    </p>
                </HashLink>
                <HashLink smooth key="options" to="/options#top">
                    <p className="leading-[2.4rem] font-normal text-[1.4rem] mt-[0.5rem] ">
                        ویژگی‌های اصلی
                    </p>
                </HashLink>
                <HashLink smooth key="faq" to="/#faq">
                    <p className="leading-[2.4rem] font-normal text-[1.4rem] mt-[0.5rem] ">
                        سوالات متداول
                    </p>
                </HashLink>
                <HashLink smooth key="prices" to="/price#top">
                    <p className="leading-[2.4rem] font-normal text-[1.4rem] mt-[0.5rem]">
                        ایجاد دوره جدید
                    </p>
                </HashLink>
            </div>
            <div className=" mr-[7.6rem] max-w-[20.6rem]">
                <p className="  font-bold text-[1.6rem] leading-[3.2rem]">
                    تماس با ما
                </p>
                <p className="leading-[2.4rem] font-normal text-[1.4rem] mt-[0.2rem] flex items-center justify-start">
                    <img
                        src={Location}
                        alt="Location"
                        className=" max-w-[2.4rem] ml-[0.3rem]"
                    />
                    <a
                        href="https://goo.gl/maps/7V2kvPYVs7uMZJWv6"
                        target="_blank"
                        rel="noreferrer"
                    >
                        تهران، کارگر شمالی، خیابان فرشی مقدم، ساختمان انتشارات
                        دانشگاه تهران، طبقه همکف، دفتر مرکزی هاب شهر هوشمند
                    </a>
                </p>
                <p className="leading-[2.4rem] font-normal text-[1.4rem] mt-[1rem] flex items-center justify-start">
                    <img
                        src={Call}
                        alt="Call"
                        className=" max-w-[2.4rem] ml-[1rem]"
                    />
                    <a href="tel:03132351534">۰۳۱-۳۲۳۵۱۵۳۴</a>
                </p>
                <p className="leading-[2.4rem] font-normal text-[1.4rem] mt-[1rem] flex items-center justify-start">
                    <img
                        src={Call}
                        alt="Call"
                        className=" max-w-[2.4rem] ml-[1rem]"
                    />
                    <a href="tel:+989138272815">۰۹۱۳۸۲۷۲۸۱۵</a>
                </p>
                <p className="leading-[2.4rem] font-normal text-[1.4rem] mt-[1rem] flex items-center justify-start">
                    <img
                        src={Message}
                        alt="Message"
                        className=" max-w-[2.4rem] ml-[1rem]"
                    />
                    <a href="mailto:bootweb@gmail.com">bootweb@gmail.com</a>
                </p>
            </div>
            <div className=" mr-[2.7rem] flex flex-col items-center justify-center">
                <p className="  font-bold text-[1.6rem] leading-[3.2rem]">
                    ما را در شبکه‌های اجتماعی دنبال کنید
                </p>
                <div className=" flex items-center justify-start mt-[1rem]">
                    <div className=" w-[4.8rem] h-[4.8rem] bg-white rounded-[50%] flex items-center justify-center">
                        <AiOutlineInstagram className=" text-[4rem] text-purple" />
                    </div>
                    <div className=" w-[4.8rem] h-[4.8rem] bg-white rounded-[50%] flex items-center justify-center mr-[2rem]">
                        <FaTelegramPlane className=" text-[3rem] text-purple" />
                    </div>
                    <div className=" w-[4.8rem] h-[4.8rem] bg-white rounded-[50%] flex items-center justify-center mr-[2rem]">
                        <AiOutlineWhatsApp className=" text-[4rem] text-purple" />
                    </div>
                </div>
                <div className="mt-[3.5rem] flex flex-row">
                    <a
                        referrerPolicy="origin"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=251667&amp;Code=ORS8gimDMkFKmWVzad3T"
                        rel="noreferrer"
                    >
                        <img
                            className="h-40"
                            referrerPolicy="origin"
                            src="https://Trustseal.eNamad.ir/logo.aspx?id=251667&amp;Code=ORS8gimDMkFKmWVzad3T"
                            alt=""
                            id="ORS8gimDMkFKmWVzad3T"
                        />
                    </a>
                    <img
                        onClick={handleClick}
                        className="cursor-pointer h-40"
                        referrerPolicy="origin"
                        id="jxlznbqewlaowlaoesgtnbqe"
                        alt="logo-samandehi"
                        src="https://logo.samandehi.ir/logo.aspx?id=124402&p=nbpdodrfshwlshwllymaodrf"
                    />
                </div>
            </div>
        </footer>
    );
}

export default Footer;
